export default __webpack_public_path__ + "static/media/pvilla7-4.df6a87a7.webp";